module.exports = __webpack_public_path__ + "static/media/form-calendar.a0dad210.svg";